import { WithLink } from '@tv2/lib-offspring/types/DeckType';
import { FunctionComponent, ReactNode } from 'react';
import { RightArrowNext } from '@tv2/ui-system/icons/next/navigation/RightArrowNext';
import { Link } from '../link/Link';

import styles from './FocusList.module.css';

export const DeckLabel: FunctionComponent<{
  displayTitle: boolean;
  title: string | null;
  titleColor: string;
  link?: WithLink['link'];
}> = ({ title, displayTitle, titleColor, link }) => {
  return (
    <div className="deck">
      <div
        style={{ marginBottom: 0 }}
        className="w-col-12 flex justify-start 576:justify-between relative"
      >
        {displayTitle && title && (
          <>
            <div className="hidden 576:inline">
              <h2
                data-testid="deck_label"
                className="text-label-l 1440:text-label-xl"
                style={{ color: titleColor }}
              >
                {title}
              </h2>
            </div>

            <div className="576:hidden">
              <AddTrackingLink link={link}>
                <h2 data-testid="deck_label" className="text-label-l" style={{ color: titleColor }}>
                  {title}
                </h2>
              </AddTrackingLink>
            </div>
          </>
        )}
        {link && (
          <AddTrackingLink link={link}>
            <div className={`cursor-pointer ${styles.link}`}>
              <span className="text-white text-label-m mr-1 hidden 576:inline">
                {link.title ?? 'Vis mere'}
              </span>
              <RightArrowNext className="invert mb-[2px]" width={16} height={16} />
            </div>
          </AddTrackingLink>
        )}
      </div>
    </div>
  );
};

const AddTrackingLink: FunctionComponent<{
  children: ReactNode;
  link?: WithLink['link'] | null;
}> = ({ link, children }) => {
  return link ? (
    <Link tracking={link.tracking} href={link.path} className="576:cursor-default">
      {children}
    </Link>
  ) : (
    <>{children}</>
  );
};
